// /src/context/LanguageContext.js
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '../components/i18n'; // <-- chemin corrigé


const LanguageContext = createContext({
  language: 'fr',
  setLanguage: () => {},
  t: translations.fr,
});

export const LanguageProvider = ({ initial = 'fr', children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem('lang') || initial || 'fr');

  // synchro localStorage + écoute des changements externes
  useEffect(() => {
    localStorage.setItem('lang', language);
    window.dispatchEvent(new CustomEvent('mp3tag:language', { detail: language }));
  }, [language]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'lang' && e.newValue) setLanguage(e.newValue);
    };
    const onCustom = (e) => {
      if (e?.detail) setLanguage(String(e.detail));
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('mp3tag:language', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('mp3tag:language', onCustom);
    };
  }, []);

  const t = useMemo(() => translations[language] || translations.fr, [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
